<template lang="pug">
  #ReservationIndex
    //- h5.text-center.pt-2 我的顧客
    .px-3(style="padding-top: 65px;")
      .d-flex.justify-content-center.mb-3.text-center
        ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
          :profileUrl="memberInfo ? memberInfo.picture_url : 'xxx'",
          :style="{ 'width': '60px', 'height': '60px'}"
          style='margin: 0px !important'
        )
        .text-left.d-flex(
          style="flex-direction: column; justify-content: center"
        )
          .ml-3
            p.mb-1.font-weight-bold 姓名： {{ memberInfo ? `${memberInfo.customer_chinese_last_name} ${memberInfo.customer_chinese_first_name}` : '' }}
            p.mb-1 暱稱名： {{ memberInfo ? memberInfo.line_display_name : '-' }}

      b-row(
        no-gutters
        class="mb-3 px-2 button-row"
      )
        p.mb-0.d-flex.align-items-center 會籍狀態： {{ }}
        p.mb-0.d-flex.align-items-center.mt-1
          span(
            style="flex: 0 0 auto;"
          ) 備註名：
          b-input.d-inline-block(
            v-model="noteName",
            :disabled="!editMode"
          )
          b-button.rounded-50.d-flex.align-items-center.justify-content-center.mx-2.button.iconBtn.iconEditBtn(
            variant="primary",
            @click="editModeHandler()"
            style='border-radius: 50px;'
          )
            i.fas.fa-pencil-alt.iconEditBtn
      b-row(
        no-gutters
        class="mb-3 px-2 button-row"
      )
        b-col(
          cols=6
        )
          b-button(
            block,
            :variant=" nowSelectItem === '客戶資料' ? 'primary' : 'outline-primary' ",
            @click="changeTypeHandler('客戶資料')"
          ) 客戶資料
        b-col(
          cols=6
        )
          b-button(
            block,
            :variant=" nowSelectItem === '預約紀錄' ? 'primary' : 'outline-primary' ",
            @click="changeTypeHandler('預約紀錄')"
            style="border: 2px solid #362e25"
          ) 預約紀錄
      .customerInfo.px-3.mb-3(
        v-show="nowSelectItem === '客戶資料'"
      )
        p.mb-1 綁定日期：{{ memberInfo ? memberInfo.latest_sa_binding_at : '-' }}
        p.mb-1 電話：{{ memberInfo ? memberInfo.mobile : '-' }}
        //- p.mb-1 顧客描述：
        //- b-textarea(
        //-   v-model="desc",
        //-   class="mb-2"
        //- )
        //- .text-center
        //-   b-button(
        //-     size="sm",
        //-     variant="primary",
        //-     @click="updateDescriptionHandler()"
        //-   ) 更新
        //- hr.my-4
        p.mb-1 客戶標籤：
        .tagContainer.w-100.d-flex.my-2
          //button.btn.button_custom-primary.tags.mr-2.mb-2.position-relative(v-for="(tagName, index) in memberInfo.tags" @click="deleteTag(index)") {{ tagName }}
        multiselect(
          v-model="userLabels",
          tag-placeholder="新增標籤",
          placeholder="選擇標籤",
          selectLabel="點擊選擇標籤",
          deselectLabel="點擊移除標籤",
          selectedLabel="已選擇",
          label="tag_name",
          track-by="tag_key",
          group-values="tag",
          group-label="group",
          :options="tagsOption",
          :multiple="true",
          :taggable="true",
          @tag="addLabelHandler",
          @remove="removeLabelHandler",
          @select="selectLabelHandler"
          noOptions="無標籤"
        )
          template(slot="Label", slot-scope='{ tags }')
          template(slot="noOptions")
            strong 請按 Enter 新增標籤
      //b-button(
      //  variant="primary",
      //  class="mb-3 ml-3",
      //  v-show="nowSelectItem === '客戶資料'"
      //)
      //  router-link.text-white(
      //    :to="{ name: 'sa-label-create' }"
      //  )
      //    i.fas.fa-tag.mr-2
      //    | 新增顧客標籤
      .reservationInfo.mb-3(
        v-show="nowSelectItem === '預約紀錄'"
      )
        b-row(
          no-gutters
          class="mb-3 mx-2"
        )
          multiselect.multiselect__dark(
            v-model="nowSelectStatus",
            tag-placeholder="輸入搜尋預約狀態",
            placeholder="請選擇預約狀態",
            selectedLabel="已選擇",
            selectLabel="點擊新增預約狀態",
            track-by="id",
            label="name",
            :options="statusList",
            :allow-empty="false"
            :searchable="false"
            noOptions="無預約狀態"
            @input="changeStatusHandler"
          )
            template(slot="noOptions")
              strong 無預約狀態

        b-card.border-0.mb-4.mx-2.customerCard.overflow-hidden(
          bg-variant="light",
          v-for="(reservation,index) in reservations",
          :key="reservation.id"
        )
          .typeRow.mb-2.d-flex.align-items-center
            i.fas.fa-border-all.mr-2
            small 服務內容：{{ reservation.reserve_type_name }}
          .reserveAtRow.mb-2.d-flex.align-items-center
            i.far.fa-calendar-check.mr-2
            small 活動時間：{{ reservation.reserve_date }} {{ reservation.start_time }}
          .typeRow.mb-2.d-flex.align-items-center
            i.fas.fa-mobile-alt.mr-2
            small.pl-1 電話(預約)：{{ reservation.mobile }}
          //-   small 活動時間：{{ reservation.reserve_date }} {{ reservation.start_time }}
          //- .statusRow.mb-2.d-flex.align-items-center
          //-   i.far.fa-check-circle.mr-2
          //-   small 預約狀態：{{ reservation.status === 'checked' ? '已確認' : reservation.status === 'checking' ? '確認中' : reservation.status === 'success' ? '完成預約' : reservation.status === 'expired' ? '已過期' : '-' }}
          //- .labelRow.d-flex.align-items-center.flex-wrap.mb-3
          //-   i.fas.fa-tag.mr-2
          //-   small 顧客標籤：
          //-   b-badge.m-1.rounded-50.px-3.py-2(
          //-     variant="primary",
          //-     v-for="(label,index) in reservation.personnel_tags"
          //-     :key="index"
          //-   ) {{ label }}
          b-row(
            no-gutters
          )
            b-col(
              :cols="4",
              class="d-flex justify-content-end",
              v-if="reservation.status === 'checked'"
            )
              b-button.button_custom-primary(
                size="sm",
                variant="primary",
                @click="cancelReservationHandler(reservation.reservation_id)"
              ) 取消預約
            b-col(
              cols=4,
              class="d-flex justify-content-center",
              v-if="reservation.status === 'checked'"
            )
              b-button.button_custom-primary(
                size="sm",
                variant="primary",
                @click="editReservationHandler(reservation)"
              ) 修改預約
            b-col(
              cols=12,
              class="d-flex justify-content-center",
              v-if="reservation.status === 'checking'"
            )
              b-button.button_custom-primary(
                size="sm",
                variant="primary",
                @click="confirmReservationHandler(reservation.reservation_id)"
              ) 完成預約
            b-col(
              cols=4,
              class="pl-1",
              v-if="reservation.status === 'checked'"
            )
              b-button.button_custom-primary(
                size="sm",
                variant="primary",
                @click="doneReservationHandler(reservation.reservation_id)"
              ) 到店諮詢
          //b-row.mt-5(
          //  no-gutters
          //  v-if="reservation.status === 'expired'"
          //)
            .expiredTextDiv.w-100.position-absolute.p-2(
              @click="doneReservationHandler(reservation.reservation_id)"
            ) {{ reservation.attend ? '已出席' : '未出席' }}
        infinite-loading(
          @infinite="infiniteHandler",
          :identifier="infiniteId",
          spinner="bubbles"
        )
          .cursor-default(slot="no-more") 無更多資料
          .cursor-default(slot="no-results") 無更多資料
          .cursor-default(slot="error") 發生錯誤，請重整重試一次
      b-row
        b-col(
          cols=12
        )
          b-button(
            variant="primary",
            block,
            @click="goToChatRoomHandler()"
          ) 與顧客一對一
      .fakePadding_h-50

</template>

<script>
import { mapState } from 'vuex';
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';
import InfiniteLoading from 'vue-infinite-loading';
import { SA_MY_CUSTOMER_RESERVATION_EDIT } from '@/router/sa/my-customer';
import { SA_CHAT_ROOM_INDEX } from '@/router/sa/chat-room';

export default {
  name: 'ReservationIndex',
  components: {
    ProfilePhotoSticker,
    InfiniteLoading
  },
  props: {
    userId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      nowSelectItem: '客戶資料',
      infiniteId: +new Date(),
      noteName: null,
      desc: null,
      editMode: false,
      userLabels: [],
      tagsOption: [],
      selectedStatus: '完成預約',
      statusList: [
        {
          id: 'checking',
          name: '確認中'
        },
        {
          id: 'checked',
          name: '完成預約'
        },
        {
          id: 'success',
          name: '到店諮詢'
        },
        {
          id: 'expired',
          name: '已過期'
        }
      ],
      nowSelectStatus: null,
    };
  },
  created() {
    const vm = this;
    vm.$swal.fire({
      title: '載入中，請稍候',
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      }
    });
    vm.nowSelectStatus = vm.statusList[0];
    vm.$store.commit('sa_my_customer/resetHandler');
    vm.$store.commit('toggleLoading', false);

    // 取得顧客詳細資料
    vm.$store.dispatch('sa_my_customer/getMemberDetailHandler', vm.userId)
      .then(() => {
        vm.$set(vm, 'noteName', vm.memberInfo.note_name);
        vm.$set(vm, 'desc', vm.memberInfo.desc);
        // 取得預約資訊
        vm.$store.dispatch('sa_my_customer/getReservationTimeListHandler')
          .then(() => {
            // 取得所有標籤
            vm.$store.dispatch('sa_my_customer/getTagsHandler')
              .then(() => {
                vm.$set(vm, 'tagsOption', vm.tags);
                // 取得該使用者的標籤
                vm.$store.dispatch('sa_my_customer/getMemberTagsHandler', vm.memberInfo.member_line_uuid)
                  .then(() => {
                    vm.$set(vm, 'userLabels', vm.memberTags);
                    vm.$swal.close();
                  });
              });
          });
      });
  },
  methods: {
    infiniteHandler($state) {
      const vm = this;
      vm.$store.dispatch('sa_my_customer/getReservationHandler', {
        current_page: parseInt(vm.pagination.current_page) + 1,
        per_page: parseInt(vm.pagination.per_page),
        status: vm.nowSelectStatus.id,
        m_id: vm.userId
      }).then(() => {
        if (vm.pagination.current_page !== vm.pagination.total_page) {
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    changeTypeHandler(type) {
      const vm = this;
      switch (type) {
        case '客戶資料':
          if (vm.nowSelectItem === '客戶資料') return;
          vm.nowSelectItem = '客戶資料';
          break;
        case '預約紀錄':
          if (vm.nowSelectItem === '預約紀錄') return;
          vm.nowSelectItem = '預約紀錄';
          vm.$store.commit('sa_my_customer/resetHandler');
          vm.infiniteId += 1;
          break;
        default:
          break;
      }
    },
    changeStatusHandler(val) {
      const vm = this;
      switch (val.id) {
        case 'checked':
          if (vm.nowSelectStatus === 'checked') return;
          vm.$store.commit('sa_my_customer/changeSelectStatus', 'checked');
          vm.$store.commit('sa_my_customer/resetHandler');
          vm.infiniteId += 1;
          break;
        case 'checking':
          if (vm.nowSelectStatus === 'checking') return;
          vm.$store.commit('sa_my_customer/changeSelectStatus', 'checking');
          vm.$store.commit('sa_my_customer/resetHandler');
          vm.infiniteId += 1;
          break;
        case 'success':
          if (vm.nowSelectStatus === 'success') return;
          vm.$store.commit('sa_my_customer/changeSelectStatus', 'success');
          vm.$store.commit('sa_my_customer/resetHandler');
          vm.infiniteId += 1;
          break;
        case 'expired':
          if (vm.nowSelectStatus === 'expired') return;
          vm.$store.commit('sa_my_customer/changeSelectStatus', 'expired');
          vm.$store.commit('sa_my_customer/resetHandler');
          vm.infiniteId += 1;
          break;
        default:
          break;
      }
    },
    editModeHandler() {
      const vm = this;
      if (!vm.editMode) {
        vm.editMode = true;
      } else {
        vm.$swal.fire({
          title: '備註名儲存中，請稍候',
          allowOutsideClick: false,
          willOpen: () => {
            vm.$swal.showLoading();
          }
        });

        vm.$store.dispatch('sa_my_customer/updateMemberNoteNameHandler', {
          memberId: vm.memberInfo.member_id,
          note_name: vm.noteName
        })
          .then(() => {
            vm.$swal.close();
            vm.$snotify.success(null, '備註名儲存成功');
            vm.editMode = false;
          });
      }
    },
    updateDescriptionHandler() {
      const vm = this;
      vm.$swal.fire({
        title: '顧客描述儲存中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          vm.$swal.showLoading();
        }
      });

      vm.$store.dispatch('sa_my_customer/updateMemberDescHandler', {
        memberId: vm.memberInfo.member_id,
        desc: vm.desc
      })
        .then(() => {
          vm.$swal.close();
          vm.$snotify.success(null, '顧客描述儲存成功');
          vm.editMode = false;
        });
    },
    cancelReservationHandler(reservationId) {
      const vm = this;
      vm.$swal.fire({
        title: '取消預約中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      vm.$store.dispatch('sa_my_customer/deleteHandler', {
        reservation_id: reservationId
      })
        .then(() => {
          vm.$swal.close();
          vm.$store.commit('sa_my_customer/resetHandler');
          vm.infiniteId += 1;
          vm.$snotify.success(null, '取消確認成功');
        });
    },
    editReservationHandler(reservation) {
      const vm = this;
      vm.$router.push({
        name: SA_MY_CUSTOMER_RESERVATION_EDIT,
        params: {
          id: reservation.reservation_id,
          userId: this.userId,
          editInfo: reservation
        }
      });
    },
    confirmReservationHandler(reservationId) {
      const vm = this;
      vm.$swal.fire({
        title: '預約確認中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      vm.$store.dispatch('sa_my_customer/checkHandler', {
        reservation_id: reservationId
      })
        .then(() => {
          vm.$swal.close();
          vm.$store.commit('sa_my_customer/resetHandler');
          vm.infiniteId += 1;
          vm.$snotify.success(null, '預約確認成功');
        });
    },
    doneReservationHandler(reservationId) {
      const vm = this;
      vm.$swal.fire({
        title: '處理中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      vm.$store.dispatch('sa_my_customer/successHandler', {
        reservation_id: reservationId
      })
        .then(() => {
          vm.$swal.close();
          vm.$store.commit('sa_my_customer/resetHandler');
          vm.infiniteId += 1;
          vm.$snotify.success(null, '到店諮詢成功');
        });
    },
    addLabelHandler(tag_name) {
      const vm = this;
      vm.$swal.fire({
        title: '標籤新增中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      // 儲存
      setTimeout(() => {
        vm.$store.dispatch('sa_my_customer/storeTagsHandler', {
          member_uuid: vm.memberInfo.member_line_uuid,
          tags: [
            {
              tag_name,
              type: 'new',
              tag_key: null,
              tag_id: null
            },
            ...vm.userLabels
          ]
        })
          .then(() => {
            // 初始化標籤
            vm.initTagsHandler();
            vm.$swal.close();
            vm.$snotify.success(null, '標籤新增成功');
          });
      }, 50);
    },
    removeLabelHandler(selectTag) {
      const vm = this;
      vm.$swal.fire({
        title: '標籤移除中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });

      // 儲存
      setTimeout(() => {
        vm.$store.dispatch('sa_my_customer/storeTagsHandler', {
          member_uuid: vm.memberInfo.member_line_uuid,
          tags: vm.userLabels
        })
          .then(() => {
            // 初始化標籤
            vm.initTagsHandler();
            vm.$swal.close();
            vm.$snotify.success(null, '標籤移除成功');
          });
      }, 50);
    },
    selectLabelHandler() {
      const vm = this;
      vm.$swal.fire({
        title: '替顧客加上標籤中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      setTimeout(() => {
        // 儲存
        vm.$store.dispatch('sa_my_customer/storeTagsHandler', {
          member_uuid: vm.memberInfo.member_line_uuid,
          tags: vm.userLabels
        })
          .then(() => {
            // 初始化標籤
            vm.initTagsHandler();
            vm.$swal.close();
            vm.$snotify.success(null, '顧客新增標籤成功');
          });
      }, 50);
    },
    // 初始化標籤
    initTagsHandler() {
      const vm = this;
      vm.$swal.fire({
        title: '標籤載入中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      // 取得所有標籤
      vm.$store.dispatch('sa_my_customer/getTagsHandler')
        .then(() => {
          vm.$set(vm, 'tagsOption', vm.tags);
          // 取得該使用者的標籤
          vm.$store.dispatch('sa_my_customer/getMemberTagsHandler', vm.memberInfo.member_line_uuid)
            .then(() => {
              vm.$set(vm, 'userLabels', vm.memberTags);
              vm.$swal.close();
            });
        });
    },
    goToChatRoomHandler() {
      const vm = this;
      vm.$router.push({
        name: SA_CHAT_ROOM_INDEX,
        params: {
          chatRoomTitle: `與${vm.memberInfo.display_name || vm.memberInfo.line_display_name}對話`,
          user: vm.memberInfo,
          sa_id: vm.memberInfo.sa_id
        }
      });
    }
  },
  computed: {
    ...mapState({
      reservations: (state) => state.sa_my_customer.reservations,
      reservationTimeList: (state) => state.sa_my_customer.reservationTimeList,
      pagination: (state) => state.sa_my_customer.pagination,
      memberInfo: (state) => state.sa_my_customer.memberInfo,
      tags: (state) => state.sa_my_customer.tags,
      memberTags: (state) => state.sa_my_customer.memberTags
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('sa_my_customer/resetHandler');
    next();
  }
};
</script>

<style scoped>
.expiredTextDiv {
  background: #888;
  left: 0;
  bottom: 0;
  color: #fff;
  text-align: center;
}
</style>
